export const SHIPMENT_STATUS = {
  loaded:     { variant: 'preparing', label: 'Chargé',     group: 'transit'   },
  departed:   { variant: 'transit',   label: 'Parti',      group: 'transit'   },
  in_transit: { variant: 'transit',   label: 'En transit', group: 'transit'   },
  arrived:    { variant: 'transit',   label: 'Arrivé',     group: 'transit'   },
  delivered:  { variant: 'delivered', label: 'Livré',      group: 'delivered' },
  incident:   { variant: 'incident',  label: 'Incident',   group: 'incident'  },
};

export const INVOICE_STATUS = {
  pending:    { variant: 'pending',   label: 'En attente', group: 'pending'   },
  paid:       { variant: 'paid',      label: 'Payée',      group: 'paid'      },
  overdue_30: { variant: 'overdue30', label: 'En retard',  group: 'overdue'   },
  overdue_60: { variant: 'overdue60', label: 'En retard',  group: 'overdue'   },
  cancelled:  { variant: 'preparing', label: 'Annulée',    group: 'cancelled' },
  disputed:   { variant: 'disputed',  label: 'Contestée',  group: 'disputed'  },
};

export function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function fmtAmount(amount, currency = 'EUR') {
  if (amount == null) return '—';
  return (
    new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .format(amount) + ' ' + currency
  );
}

export function groupByMonth(items, dateField = 'createdAt', months = 6) {
  const now = new Date();
  return Array.from({ length: months }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - (months - 1 - i), 1);
    return {
      label: d.toLocaleDateString('fr-FR', { month: 'short' }),
      value: items.filter((item) => {
        const id = new Date(item[dateField]);
        return id.getFullYear() === d.getFullYear() && id.getMonth() === d.getMonth();
      }).length,
    };
  });
}
